var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(`transform: rotate(90deg)`),attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 3L5 7L9 3","stroke":_vm.disabled ? '#DFE2EB' : '#727D94',"stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }